import { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';

import styled from 'styled-components';

const Checkbox = styled(Form.Check)`
	margin-bottom: 0;

	label:hover,
	input:hover {
		cursor: pointer;
	}

	label {
		font-weight: 400;
		user-select: none;
	}
`;

const LayerCheckbox = ({
	id,
	label,
	onCheck,
	onUncheck,
	defaultChecked = true,
	layer = null,
	disabled,
}) => {
	const [checked, setChecked] = useState(defaultChecked);

	const handleCheckChange = value => {
		setChecked(value);

		if (value) {
			onCheck && onCheck();
		} else {
			onUncheck && onUncheck();
		}
	};

	useEffect(() => {
		if (layer !== null) {
			// Add an event listener to the layer to update the checkbox when the layer visibility changes
			const handleLayerChange = () => {
				const layerVisibility = layer.getVisible() ?? false;
				setChecked(layerVisibility);
			};

			layer.on('change:visible', handleLayerChange);

			// Clean up function to remove the event listener when the component unmounts
			return () => {
				layer.un('change:visible', handleLayerChange);
				setChecked(defaultChecked);
			};
		}
	}, [layer]);

	return (
		<Checkbox
			id={id}
			type="checkbox"
			label={label}
			aria-label={`Toggle ${label} layer view`}
			checked={checked}
			onChange={e => {
				handleCheckChange(e.target.checked);
			}}
			disabled={disabled}
		/>
	);
};

export default LayerCheckbox;
